<template>Que haces aqui</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      name: "",
      nameWork: "",
      chart: undefined,
      formFields: [
        {
          id: 1,
          type: "date",
          value: "",
        },
        {
          id: 2,
          type: "decimal",
          value: "",
        },
        {
          id: 3,
          type: "text",
          value: "",
        },
      ],
    };
  },
  methods: {
    coso(index, event) {
      this.formFields[index].value = event;
      console.log(this.formFields[index]);
      console.log(event);
    },
  },
});
</script>

<style lang="sass" scoped>
.full-modal
  .ant-modal
    max-width: 100%
    top: 0
    padding-bottom: 0
    margin: 0

  .ant-modal-content
    display: flex
    flex-direction: column
    height: calc(100vh)

  .ant-modal-body
    flex: 1
</style>
